import { Style } from "../Styles";
import { css } from "lit";

export const styles = [
    Style,
    css`
        :host {
            display: block;
            width: 100%;
            height: 100%;
        }

        ds-media {
            width: 100%;
            height: 100%;
        }

        sl-carousel {
            width: 100%;
            height: 100%;
            padding-bottom: 1em;
        }

        sl-carousel::part(scroll-container) {
            grid-area: 1 / 1 / span 1 / span 3;
        }

        sl-carousel-item {
            width: 100%;
            height: 100%;
        }
    `,
];
